import React, { useEffect, useState } from 'react';
import {
    Alert,
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    Checkbox,
    ListItemAvatar,
    TextField,
    Typography,
    FormControlLabel
} from '@mui/material';
import axios from 'axios';
import { token, apiUrl } from '../../../../../api';
import api from '../../../../services/api';

const API_BASE = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:9000';

const AppSettings = ({ onClose }) => {
    const [status, setStatus] = useState({ type: '', message: '' });
    const [detalhesApp, setDetalhesApp] = useState(null);
    const [app, setApp] = useState(null);
    const [solicitouCriarApp, setSolicitouCriarApp] = useState(false);
    const [openInfoApp, setOpenInfoApp] = useState(false);
    // const [checked, setChecked] = React.useState(true);

    const [listaApps, setListaApps] = useState([]);
    const [wizardData, setWizardData] = React.useState({
        app: {
            name: '',
            description: ''
        }
    });

    // const handleChangeVoltar = () => {
    //     onclose = false
    // setChecked(event.target.checked);
    // };

    useEffect(() => {
        loadApps();
    }, [openInfoApp]);

    useEffect(() => {
        console.log(`listaApps: ${JSON.stringify(listaApps)}`);
    }, [listaApps]);

    const [ids, setIds] = React.useState({
        appId: null,
        keyId: null,
        integrationId: null,
        switchboardId: null
    });

    const createApp = async () => {
        console.log('Criando App:', wizardData.app);
        const payload = {
            app: {
                settings: {
                    appLocalizationEnabled: true,
                    echoPostback: true,
                    maskCreditCardNumbers: false,
                    multiConvoEnabled: false,
                    useAnimalNames: false,
                    endSessionEnabled: false,
                    disableConversationReopen: false
                },
                metadata: {
                    accountId: 1,
                    createdBy: 'Backend',
                    zendesk_subdomain: 'teste'
                },
                displayName: wizardData.app.name,
                subdomain: wizardData.app.subdomain
            }
        };
        console.log('Payload do App:', payload);

        try {
            const res = await api.post(`v1/apps/`, payload);
            // const res = await axios.post(`${apiUrl}/api/v1/apps/`, payload, {
            //     headers: { Authorization: token }
            // });
            if (res.data) {
                setIds((prev) => ({ ...prev, appId: res.data.app.id }));
                setStatus({ type: 'success', message: 'App criado com sucesso!' });
                console.log(`App ${res.data.app.id} criado com sucesso!`);
                console.log('App criado com sucesso!');
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao criar App.'
                });
            }
        } catch (error) {
            setStatus({
                type: 'error',
                message: error.response?.data?.detail || 'Erro ao criar App.'
            });
            console.error('Erro ao criar app:', error.response?.data || error);
        }
    };

    const loadApps = async () => {
        console.log('entrou em loadApps');
        try {
            const res = await api.get(`v1/apps/`);
            // const res = await axios.get(`${API_BASE}/api/v1/apps/`, {
            //     headers: {
            //         Authorization: token,
            //         'Content-Type': 'application/json'
            //     }
            // });
            if (res.data) {
                setListaApps(res.data.apps);
            } else {
                setStatus({
                    type: 'error',
                    message: 'Erro ao carregar Apps'
                });
            }
        } catch (err) {
            console.error('Erro ao carregar Apps', err);
            setStatus({
                type: 'error',
                message: 'Erro ao carregar Apps'
            });
        }
    };

    const minimizaInfoApp = () => {
        setOpenInfoApp(false);
        setDetalhesApp(null);
        setStatus({ type: '', message: '' });
    };

    const definirAppPadrao = async () => {
        // detalhesApp
        try {
            const payload = {
                is_default: true
            };
            const res = await api.patch(`v1/apps/${detalhesApp.id}/`, payload);

            // await axios.patch(`${API_BASE}/api/v1/apps/${detalhesApp.id}/`, payload, {
            //     headers: {
            //         Authorization: token,
            //         'Content-Type': 'application/json'
            //     }
            // });
            if (res.data) {
                setStatus({ type: 'success', message: 'App Definido como padrão!' });
                loadApps();
            } else {
                setStatus({
                    type: 'error',
                    message: 'Não foi possível definir App como padrão.'
                });
            }
        } catch (err) {
            setStatus({
                type: 'error',
                message: err.response?.data?.detail || 'Erro ao definir App como padrão'
            });
        }
    };

    const deletarApp = async () => {
        try {
            if (listaApps.length === 1) {
                setStatus({ type: 'error', message: 'Você deve ter pelo menos 1 App ativo.' });
                return;
            }
            const res = api.delete(`v1/apps/${detalhesApp.id}/`);
            // if (res.data) {
            setStatus({ type: 'success', message: 'App deletado com sucesso!' });
            console.log(`App ${detalhesApp.id} deletado com sucesso!`);
            // Recarregar a lista de apps após a deleção
            loadApps();
            // } else {
            //     setStatus({ type: 'error', message: 'Não foi possível deletar App' });
            // }
        } catch (err) {
            setStatus({
                type: 'error',
                message: err.response?.data?.detail || 'Erro ao deletar App.'
            });
            console.error('Erro ao deletar App', err);
        }
    };

    return (
        <Card sx={{ maxWidth: '100%', maxHeight: '100%' }}>
            <CardContent>
                <Typography variant="h2">Configurações de App</Typography>

                <Typography variant="h5" marginTop={3}>
                    Lista de Apps
                </Typography>

                {!solicitouCriarApp && !openInfoApp && (
                    <>
                        {status.message && (
                            <Alert severity={status.type} sx={{ mb: 1 }}>
                                {status.message}
                            </Alert>
                        )}
                        <CardContent>
                            {/* Cabeçalho */}
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '100px 210px 100px',
                                    fontWeight: 'bold',
                                    pb: 1,
                                    borderBottom: '2px solid #eee'
                                    // marginTop: 3
                                }}
                            >
                                <Typography>Nome</Typography>
                                <Typography>ID</Typography>
                                {/* <Typography>Dominio</Typography> */}
                                <Typography>Selecionado</Typography>
                            </Box>

                            {/* Linhas da tabela */}
                            {listaApps.map((app) => (
                                <Box
                                    key={app.id}
                                    sx={{
                                        display: 'grid',
                                        gridTemplateColumns: '100px 210px 100px',
                                        borderBottom: '1px solid #f0f0f0',
                                        py: 1,
                                        alignItems: 'center',
                                        cursor: 'pointer'
                                    }}
                                    onClick={(e) => {
                                        console.log('clicou no app:', app);
                                        setOpenInfoApp(true);
                                        setDetalhesApp(app);
                                        // if (e.target.tagName !== 'INPUT' && !e.target.dataset.org) {
                                        //     handleOpenUser(user);
                                        // }
                                    }}
                                >
                                    {/* Nome */}
                                    <Typography>{app.displayName}</Typography>

                                    {/* ID */}
                                    <Typography>{app.id || '—'}</Typography>

                                    {/* Subdominio */}
                                    {/* <Typography>{app.subdomain || 'Subdomínio'}</Typography> */}

                                    {/* Default */}
                                    {/* {app.is_default === false && <Typography></Typography>}
                                    {app.is_default === true && <Typography>Padrão</Typography>}
                                     */}

                                    {app.is_default === true && (
                                        <Checkbox checked={true} slotProps={{ input: { 'aria-label': 'controlled' } }} />
                                    )}

                                    {app.is_default === false && (
                                        <Checkbox checked={false} slotProps={{ input: { 'aria-label': 'controlled' } }} />
                                    )}
                                </Box>
                            ))}
                        </CardContent>

                        <Button variant="contained" sx={{ mr: 1, mt: 3, backgroundColor: '#32CD32' }} onClick={setSolicitouCriarApp}>
                            Adicionar App
                        </Button>

                        <Button variant="outlined" sx={{ mr: 1, mt: 3, backgroundColor: '#dba08a' }} color="secondary" onClick={onClose}>
                            Voltar
                        </Button>
                    </>
                )}

                {openInfoApp && !solicitouCriarApp && (
                    <>
                        {status.message && (
                            <Alert severity={status.type} sx={{ mb: 2 }}>
                                {status.message}
                            </Alert>
                        )}
                        <Typography variant="h5" marginTop={3}>
                            Nome: {detalhesApp.displayName}
                        </Typography>

                        <Button
                            variant="outlined"
                            sx={{ mr: 1, mt: 3, backgroundColor: '#32CD32' }}
                            color="secondary"
                            onClick={minimizaInfoApp}
                        >
                            Voltar
                        </Button>

                        {detalhesApp.is_default === false && (
                            <Button
                                variant="outlined"
                                sx={{ mr: 1, mt: 3, backgroundColor: '#59aad9' }}
                                color="secondary"
                                onClick={definirAppPadrao}
                                disable
                            >
                                Definir como padrão
                            </Button>
                        )}

                        <Button variant="outlined" sx={{ mr: 1, mt: 3, backgroundColor: '#dba08a' }} color="secondary" onClick={deletarApp}>
                            Apagar App
                        </Button>
                    </>
                )}

                {solicitouCriarApp && !openInfoApp && (
                    <>
                        {status.message && (
                            <Alert severity={status.type} sx={{ mb: 2 }}>
                                {status.message}
                            </Alert>
                        )}
                        <Typography variant="h5" marginTop={3}>
                            Adicionar um App
                        </Typography>
                        <TextField
                            label="Nome do App"
                            fullWidth
                            margin="normal"
                            value={wizardData.app.name}
                            onChange={(e) =>
                                setWizardData({
                                    ...wizardData,
                                    app: { ...wizardData.app, name: e.target.value }
                                })
                            }
                        />

                        {/* <TextField
                            label="Subdominio"
                            fullWidth
                            multiline
                            rows={1}
                            margin="normal"
                            value={wizardData.app.subdomain}
                            onChange={(e) =>
                                setWizardData({
                                    ...wizardData,
                                    app: { ...wizardData.app, subdomain: e.target.value }
                                })
                            }
                        /> */}

                        {/* <TextField
                            label="Descrição"
                            fullWidth
                            multiline
                            rows={3}
                            margin="normal"
                            value={wizardData.app.description}
                            onChange={(e) =>
                                setWizardData({
                                    ...wizardData,
                                    app: { ...wizardData.app, description: e.target.value }
                                })
                            }
                        /> */}
                        <Box sx={{ mt: 2 }}>
                            <Button variant="contained" onClick={createApp} sx={{ mr: 1, backgroundColor: '#32CD32' }}>
                                Criar App
                            </Button>

                            <Button variant="outlined" color="secondary" onClick={onClose}>
                                Voltar
                            </Button>
                        </Box>
                    </>
                )}
            </CardContent>
        </Card>
    );
};

export default AppSettings;
